import { useTopBar } from "./topBar/useTopBar";
import { UserDetailsPopup } from "./topBar/userDetailsPopup";
import { NotificationsButton } from "./topBar/notificationsButton";
import { clsx } from "clsx/lite";
import { SegmentedControl } from "../segmentedControl/segmentedControl";
import { PspAvatar } from "../pspAvatar/pspAvatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronLeft,
  faWrench,
} from "@fortawesome/pro-regular-svg-icons";
import { translate } from "@/config/translator";
import { Tooltip } from "@fluentui/react-components";

export function TopBar() {
  const {
    isInBackoffice,
    navigateToAdminPanel,
    isTablet,
    userDetailsOpen,
    setUserDetailsOpen,
    selectedMandate,
    user,
    lang,
    isInAdminPanel,
    currentAppLocation,
    onChangeAppLocation,
    appLocationOptions,
    navigateToBackoffice,
    isAdmin,
    isSuperEmployee,
  } = useTopBar();

  return (
    <div
      className={clsx(
        "w-full",
        isInBackoffice || isInAdminPanel
          ? "bg-canvas-black"
          : "bg-canvas-tertiary",
        "z-10",
        "flex-row",
        "items-center",
        "justify-between",
        "pl-2",
        "h-24",
        "pr-8",
        "hidden",
        "tablet:flex",
        "duration-200",
        "ease-in-out",
        "relative",
        "border-b",
        "border-neutral",
      )}
    >
      <div
        className={clsx(
          isInBackoffice ? "w-full" : "w-0",
          "h-0.5",
          "duration-500",
          "ease-in-out",
          "bottom-0",
          "left-0",
          "absolute",
          "bg-primary",
        )}
      />
      <div className="flex flex-row gap-12">
        <div className="w-68 flex flex-row justify-center items-center h-full">
          <div className="flex flex-row items-end gap-2">
            <img
              src={
                isInBackoffice || isInAdminPanel
                  ? "/logo_white_small.svg"
                  : "/logo.svg"
              }
              className={isInBackoffice || isInAdminPanel ? "w-20" : "w-44"}
            />
            {(isInBackoffice || isInAdminPanel) && (
              <div className="text-disabled font-medium text-2xl/4">
                Backoffice
              </div>
            )}
          </div>
        </div>
        {user !== undefined &&
          (user.scopes.includes("admin") ||
            user.scopes.includes("employee")) && (
            <SegmentedControl
              stretchOnHover
              isDark={isInBackoffice}
              value={currentAppLocation}
              onChange={onChangeAppLocation}
              options={appLocationOptions}
            />
          )}
      </div>
      {user && (
        <div className="flex flex-row gap-4 items-center">
          {isInBackoffice && (isAdmin || isSuperEmployee) && (
            <button
              onClick={
                isInAdminPanel ? navigateToBackoffice : navigateToAdminPanel
              }
              className={clsx(
                "cursor-pointer",
                "hover:bg-canvas-secondary-dark",
                "duration-200",
                "rounded-lg",
                "ease-in-out",
                "aspect-square",
                "p-2",
              )}
            >
              <FontAwesomeIcon
                icon={isInAdminPanel ? faChevronLeft : faWrench}
                className="text-font-secondary-dark text-2xl"
              />
            </button>
          )}

          <NotificationsButton />

          <div className="relative">
            <button
              className={clsx(
                "flex-row",
                "flex",
                "gap-4",
                "items-center",
                "cursor-pointer",
                "duration-200",
                "ease-in-out",
                isInBackoffice
                  ? "hover:bg-canvas-secondary-dark"
                  : "hover:bg-canvas-secondary",
                "group",
                "rounded-lg",
                "p-3",
              )}
              onClick={() => setUserDetailsOpen(true)}
            >
              <div className="flex flex-col text-right justify-center h-full">
                <div
                  className={clsx(
                    isInBackoffice || isInAdminPanel
                      ? "text-font-white"
                      : "text-font-black",
                    "font-medium",
                    "text-base",
                  )}
                >
                  <Tooltip
                    visible={
                      !selectedMandate || selectedMandate.name.length > 30
                        ? false
                        : undefined
                    }
                    relationship="label"
                    content={selectedMandate?.name ?? ""}
                  >
                    <div>
                      {selectedMandate
                        ? selectedMandate.name.slice(undefined, 30) +
                          (selectedMandate.name.length > 30 ? "..." : "")
                        : translate("pleaseSelectMandateShort", lang)}
                    </div>
                  </Tooltip>
                </div>
                {selectedMandate && (
                  <div className="flex flex-row justify-end items-center">
                    <div
                      className={clsx(
                        isInBackoffice || isInAdminPanel
                          ? "text-font-secondary-dark"
                          : "text-font-secondary",
                        "text-base",
                      )}
                    >
                      {selectedMandate.taxNumber.toUpperCase()}
                    </div>
                  </div>
                )}
              </div>
              <div className="flex flex-row items-center gap-2">
                <PspAvatar isDark={isInBackoffice} name={user?.name ?? "?"} />
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={clsx(
                    "duration-200",
                    "ease-in-out",
                    "text-font-secondary",
                    "text-lg",
                  )}
                />
              </div>
            </button>

            {/* POPUP */}
            {isTablet && userDetailsOpen && (
              <UserDetailsPopup
                isOpen={userDetailsOpen}
                setIsOpen={setUserDetailsOpen}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
